<template>
   <artmisads-modal
      v-model:open="showDeactivateModal"
      :title="$t('seller.brandsPage.dropdownDeactivateTitle')"
      :width="500"
      :onCancel="onCancel"
      :destroyOnClose="true"
      :maskClosable="false"
    >
      <div class="inactive-content">
        <p v-if="productListStatus?.activeProductVariationCount">{{ $t('seller.brandsPage.dropdownDeactivateBodyVar') }}</p>
        <p v-else>{{ $t('seller.brandsPage.dropdownDeactivateBodySimple') }}</p>
      </div>
      <template #footer>
        <artmisads-button @click="() => setShowDeactivateModal(false)">{{ $t('seller.common.cancel') }}</artmisads-button>
        <artmisads-button @click="confirmInactive" type="primary">{{ $t('seller.common.confirm') }}</artmisads-button>
      </template>
    </artmisads-modal>
    <artmisads-modal v-model:open="showActiveModal" :width="500" :title="$t('seller.brandsPage.dropdownActivateTitle')"
      :ok-text="$t('seller.common.confirm')" @ok="confirmActive" @cancel="setShowActiveModal(false)">
      <div class="active-product">
        <div class="title-ext">
          {{ $t('seller.brandsPage.dropdownActivateBody') }}
        </div>
      </div>
    </artmisads-modal>
  <div ref="operationRef">
    <a-dropdown :getPopupContainer="() => $refs.operationRef" trigger="click"
      @openChange="getProductVariationsMultiple">
      <template #overlay>
        <artmisads-dropdown-menu @click="handleMenuClick">
          <a-spin :spinning="loading">
            <a-menu-item key="activateProducts"
              :disabled="(!props.selectedRowKeys.length || productListStatus?.inactiveProductCount) ? false : true">
              <div class="actions-item">
                <span>{{ $t('seller.common.activateProducts') }}</span>
                <span v-if="productListStatus?.inactiveProductCount && props.selectedRowKeys.length" class="action-num">
                  <span class="num">{{ productListStatus?.inactiveProductCount || '' }}</span>
                  <Icon name="jiahao-cu" class="minus" v-show="productListStatus?.inactiveProductVariationCount"></Icon>
                  <span class="variation-num" v-show="productListStatus?.inactiveProductVariationCount">{{
                    productListStatus?.inactiveProductVariationCount }} </span>
                  <a-tooltip placement="bottom" :getPopupContainer="() => $refs.operationRef"
                    v-if="productListStatus?.inactiveProductVariationCount">
                    <template #title>
                      <div class="pop-title">{{ $t('seller.brandsPage.variationCountTooltip') }}
                      </div>
                    </template>
                    <Icon name="wenhao-tianchong" class="question-icon"></Icon>
                  </a-tooltip>
                </span>
              </div>
            </a-menu-item>
            <a-menu-item key="setPublicCommission">
              <div class="actions-item">
                <span>{{ $t('seller.brandsPage.setPublicCommission') }}</span>
                <span class="action-num">
                  <span v-if="props.selectedRowKeys.length" class="num">{{ props.selectedRowKeys.length }}</span>
                </span>
              </div>
            </a-menu-item>
            <a-menu-item key="deactivateProducts"
              :disabled="(!props.selectedRowKeys.length || productListStatus?.activeProductCount) ? false : true">
              <div class="actions-item">
                <span>{{ $t('seller.common.deactivateProducts') }}</span>
                <span v-if="productListStatus?.activeProductCount && props.selectedRowKeys.length" class="action-num">
                  <span class="num">{{ productListStatus?.activeProductCount || '' }}</span>
                  <Icon name="jiahao-cu" class="minus" v-show="productListStatus?.activeProductVariationCount"></Icon>
                  <span class="variation-num" v-show="productListStatus?.activeProductVariationCount">{{
                    productListStatus?.activeProductVariationCount }} </span>
                  <a-tooltip placement="bottom" :getPopupContainer="() => $refs.operationRef"
                    v-if="productListStatus?.activeProductVariationCount">
                    <template #title>
                      <div class="pop-title">{{ $t('seller.brandsPage.variationCountTooltip') }}
                      </div>
                    </template>
                    <Icon name="wenhao-tianchong" class="question-icon"></Icon>
                  </a-tooltip>
                </span>
              </div>
            </a-menu-item>
            <a-menu-item key="clearSelection">{{ $t('seller.brandsPage.clearSelection') }}</a-menu-item>
          </a-spin>
        </artmisads-dropdown-menu>

      </template>
      <artmisads-select-button showDownIcon="true">{{ $t('seller.brandsPage.actions') }}</artmisads-select-button>
    </a-dropdown>
  </div>
</template>
<script setup>
import { ref,reactive } from 'vue';
import { productsApi } from "@/server/index"
import { message } from 'ant-design-vue';
import Icon from "@/components/Icon.vue"
import i18n from '~/i18n'

const props = defineProps({
  selectedRowKeys: {
    type: Array,
    default: () => [],
  },
  onChangeActiveItems: {
    type: Function,
    default: () => {},
  },
  setSelectedRowKeys: {
    type: Function,
    default: () => {},
  },
  setShowSetCommission: {
    type: Function,
    default: () => {},
  },
})
const productListStatus = reactive({})
const loading = ref(false)
const showDeactivateModal = ref(false);
const showActiveModal = ref(false);
const getProductVariationsMultiple = async (status) => {
  if (!status || !props.selectedRowKeys.length) {
    return
  }
  loading.value = true
  let res = await productsApi.getProductVariations(props.selectedRowKeys)
  productListStatus.activeProductCount = res.data.activeProductCount
  productListStatus.activeProductVariationCount = res.data.activeProductVariationCount
  productListStatus.inactiveProductCount = res.data.inactiveProductCount
  productListStatus.inactiveProductVariationCount = res.data.inactiveProductVariationCount
  loading.value = false
}
const setShowDeactivateModal = status => {
    showDeactivateModal.value = status;
  }
  const setShowActiveModal = status => {
    showActiveModal.value = status;
  }
  const confirmInactive = async () => {
    showDeactivateModal.value = false;
    props.onChangeActiveItems('inActive', props.selectedRowKeys);
  }
  const confirmActive = async () => {
    showActiveModal.value = false;
    props.onChangeActiveItems('active', props.selectedRowKeys);
  }
const handleMenuClick = async ({ key }) => {
    if (!props.selectedRowKeys.length && key !== 'clearSelection') {
      return message.warning(i18n.global.t('seller.brandsPage.selectProductsFirst'));
    };
    if (key === 'activateProducts') {
      if(productListStatus?.inactiveProductVariationCount){
        setShowActiveModal(true);
      }else{
        props.onChangeActiveItems('active', props.selectedRowKeys);
      }
      
      
    } else if (key === 'deactivateProducts') {
      setShowDeactivateModal(true);
    } else if (key === 'clearSelection') {
      props.setSelectedRowKeys([]);
    } else if (key === 'setPublicCommission') {
      props.setShowSetCommission(true);
    }
  }
</script>
<style lang="less" scoped>
.variation-num {
  align-self: center;
  margin-right: 2px;
  height: 18px;
  min-width: 20px;
  padding-inline: 4px;
  background: rgba(255, 211, 88, 0.2);
  border-radius: 4px;
  font-weight: 500;
  font-size: var(--font-size-mormal);
  color: var(--dark-1);
  text-align: center;
  line-height: 16px;
  border: 1px solid rgba(255, 211, 88, 0.4);
}

.action-num {
  display: flex;
  align-items: center;
}

.question-icon {
  color: var(--dark-4);
}

.minus {
  font-size: 10px;
  align-self: center;
  margin-inline: 4px;
  // font-weight: 600;
  line-height: 18px;
  height: 18px;
  color: var(--dark-1);
}
</style>